import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import {
  saveConditionDescription,
  saveConditionType,
  selectConditionDeviceType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectConditionDeviceType
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/SelectConditionDeviceType/SelectConditionDeviceType'
import SelectConditionDeviceTypeIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/SelectConditionDeviceType/SelectConditionDeviceType'
import { withAccessDenied, withNotifications } from '@app/hocs'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? SelectConditionDeviceTypeIOS : SelectConditionDeviceType

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isNCentral } = state.unit
  return {
    isMobile,
    path,
    isNCentral,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  selectConditionDeviceType,
  saveConditionType,
  saveConditionDescription,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
const SelectConditionDeviceTypeEnhanced = connect(mapStateToProps, mapDispatchToProps)(enhance)

export default SelectConditionDeviceTypeEnhanced
